import {UWQuestions} from 'ApplicationEntry/models/UnderwritingQuestions';
import * as UW from 'ApplicationEntry/models/UnderwritingQuestions';
import {question} from 'ApplicationEntry/models/UWQuestionsModel';
import {Async, Loading} from 'Core/models/Async';
import * as I from 'immutable';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum UWQuestionsActionType {
  CHANGE_QUESTIONS = 'uwQuestions/CHANGE_QUESTIONS',
  CHANGE_ANSWERS = 'uwQuestions/CHANGE_ANSWERS',
  GET_QUESTIONS = 'uwQuestions/GET_QUESTIONS',
  CHANGE_MULT_ANSWERS = 'uwQuestions/CHANGE_MULT_ANSWERS',
  REMOVE_QUESTIONS = 'uwQuestions/REMOVE_QUESTIONS',
  UNASSIGN_QUESTIONS = 'uwQuestions/UNASSIGN_QUESTIONS',
  CHANGE_ANSWERS_HEIGHT = 'CHANGE_ANSWERS_HEIGHT',
  CHANGE_ANSWERS_WEIGHT = 'CHANGE_ANSWERS_WEIGHT',
  CHANGE_ANSWERS_ALL_QUESTIONS = 'CHANGE_ANSWERS_ALL_QUESTIONS',
  CHANGE_ANSWERS_ALL_NO_QUESTIONS = 'CHANGE_ANSWERS_ALL_NO_QUESTIONS',
}

export const isUWQuestionsAction = (action: any): action is UWQuestionsAction =>
  action.type in reverseEnum(UWQuestionsActionType);

export const changeQuestions = (questions: Async<I.List<question>>) =>
  createAction(UWQuestionsActionType.CHANGE_QUESTIONS, {questions});
export const changeAnswer = (answer: boolean, index: number) =>
  createAction(UWQuestionsActionType.CHANGE_ANSWERS, {answer, index});
export const changeMultAnswers = (answers: I.List<boolean | string>) =>
  createAction(UWQuestionsActionType.CHANGE_MULT_ANSWERS, {answers});
export const getQuestionList = (formNumber: string) => createAction(UWQuestionsActionType.GET_QUESTIONS, {formNumber});
export const removeQuestions = () => createAction(UWQuestionsActionType.REMOVE_QUESTIONS);
export const UnassignQuestions = () => createAction(UWQuestionsActionType.UNASSIGN_QUESTIONS);
export const changeHeight = (feet: number | '', inches: number | '', targetElement: string | '') => {
  return createAction(UWQuestionsActionType.CHANGE_ANSWERS_HEIGHT, {feet, inches, targetElement});
};
export const changeAnswerforAllQuestions = (answer: boolean, index: number) =>
  createAction(UWQuestionsActionType.CHANGE_ANSWERS_ALL_QUESTIONS, {answer, index});
export const changeAnswersforAllQuestionsNoCheckBox = (answer: boolean, index: number) =>
  createAction(UWQuestionsActionType.CHANGE_ANSWERS_ALL_NO_QUESTIONS, {answer, index});

export const changeWeight = (weight: string, targetElement: string | '') =>
  createAction(UWQuestionsActionType.CHANGE_ANSWERS_WEIGHT, {weight, targetElement});

export type UWQuestionsAction =
  | ReturnType<typeof getQuestionList>
  | ReturnType<typeof changeQuestions>
  | ReturnType<typeof changeAnswer>
  | ReturnType<typeof changeMultAnswers>
  | ReturnType<typeof removeQuestions>
  | ReturnType<typeof UnassignQuestions>
  | ReturnType<typeof changeHeight>
  | ReturnType<typeof changeWeight>
  | ReturnType<typeof changeAnswerforAllQuestions>
  | ReturnType<typeof changeAnswersforAllQuestionsNoCheckBox>;

type UWQuestionsState = UWQuestions;

export default (state: UWQuestionsState, action: UWQuestionsAction): UWQuestionsState => {
  switch (action.type) {
    case UWQuestionsActionType.CHANGE_ANSWERS:
      return UW.changeAnswers(action.payload.answer, action.payload.index)(state);
    case UWQuestionsActionType.CHANGE_QUESTIONS:
      return UW.changeQuestions(action.payload.questions)(state);
    case UWQuestionsActionType.GET_QUESTIONS:
      return UW.changeQuestions(new Loading())(state);
    case UWQuestionsActionType.CHANGE_MULT_ANSWERS:
      return UW.changeMultAnswers(action.payload.answers)(state);
    case UWQuestionsActionType.REMOVE_QUESTIONS:
      return UW.removeQuestions()(state);
    case UWQuestionsActionType.UNASSIGN_QUESTIONS:
      return UW.UnassignQuestions()(state);
    case UWQuestionsActionType.CHANGE_ANSWERS_HEIGHT:
      return UW.changeHeight(action.payload.feet, action.payload.inches, action.payload.targetElement)(state);
    case UWQuestionsActionType.CHANGE_ANSWERS_WEIGHT:
      return UW.changeWeight(action.payload.weight, action.payload.targetElement)(state);
    case UWQuestionsActionType.CHANGE_ANSWERS_ALL_QUESTIONS:
      return UW.changeAnswersforAllQuestions(action.payload.answer, action.payload.index)(state);
    case UWQuestionsActionType.CHANGE_ANSWERS_ALL_NO_QUESTIONS:
      return UW.changeAnswersforAllQuestionsNoCheckBox(action.payload.answer, action.payload.index)(state);

    default:
      return state;
  }
};
